import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';

import { ApplicationFacade, CustomerAuthFacade } from '@ridango/components';

@Component({
    selector: 'rwidget-cookie-notification',
    templateUrl: './cookie-notification.component.html',
    styleUrls: ['./cookie-notification.component.scss']
})
export class CookieNotificationComponent implements OnInit {
    cookiesAccepted$ = this.authFacade.isCookiesAccepted$;
    cookieConsentLink: string;

    @Output() onCookiesAccepted = new EventEmitter<any>();

    constructor(
        @Inject('ENV') private env: any,
        private authFacade: CustomerAuthFacade,
        private applicationFacade: ApplicationFacade
    ) {}

    ngOnInit() {
        this.cookieConsentLink = this.env.COOKIE_CONSENT_LINK
            ? `/${this.env.COOKIE_CONSENT_LINK}`
            : '/terms-and-conditions';
    }

    closeMobileMenu() {
        this.applicationFacade.setMobileMenuOpen(false);
    }

    onAcceptCookies() {
        // TODO: should move to facade/service
        localStorage.setItem(`${this.env.APP_NAME}-cookies-accepted`, '1');
        // should be set in state. auth maybe ?
        this.authFacade.acceptCookies(true);
        // this.cookiesAccepted = true;

        // if would be in state, this would not be necessary
        // setTimeout(() => this.accessibilityBarEl.nativeElement.focus());
        // this.onCookiesAccepted.emit();
    }
}
